import { apiFetch } from '../../actions/apiActions';
import { toast } from 'react-toastify';
import { makeActionCreator } from '../../utils';
import { newOrderVersionCreated, orderLoadRequested } from '../../OrdersPage/actions/orderActions';

export const ORDER_ID_CHANGED = "ORDER_ID_CHANGED";
export const DATA_CHANGED = "DATA_CHANGED";
export const ORDER_DATA_CHANGED = "ORDER_DATA_CHANGED";
export const ORDER_DATA_PROBLEM_DESCRIPTION_CHANGED = "ORDER_DATA_PROBLEM_DESCRIPTION_CHANGED";
export const ORDER_DATA_OFFICIAL_NAME_CHANGED = "ORDER_DATA_OFFICIAL_NAME_CHANGED";
export const ORDER_DATA_REQUIRED_CREATE_NEW_ORDER_VERSION_CHANGED = "ORDER_DATA_REQUIRED_CREATE_NEW_ORDER_VERSION_CHANGED";
export const ORDER_DATA_VERSION_METADATA_MESSAGE_CHANGED = "ORDER_DATA_VERSION_METADATA_MESSAGE_CHANGED";
export const INSTRUCTION_VERSIONS_CHANGED = "INSTRUCTION_VERSIONS_CHANGED";
export const INSTRUCTION_VERSION_DATA_CHANGED = "INSTRUCTION_VERSION_DATA_CHANGED";
export const INSTRUCTION_VERSION_PARAGRAPH_ADD = "INSTRUCTION_VERSION_PARAGRAPH_ADD";
export const INSTRUCTION_VERSION_PARAGRAPH_DELETE = "INSTRUCTION_VERSION_PARAGRAPH_DELETE";
export const INSTRUCTION_WAS_EDITED = "INSTRUCTION_WAS_EDITED";
export const INSTRUCTION_LOADING = "INSTRUCTION_LOADING";
export const INSTRUCTION_PARAGRAPH_UP = "INSTRUCTION_PARAGRAPH_UP";
export const INSTRUCTION_PARAGRAPH_DOWN = "INSTRUCTION_PARAGRAPH_DOWN";
export const INSTRUCTION_SAVE_ERROR = "INSTRUCTION_SAVE_ERROR";

export const orderIdChanged = makeActionCreator(ORDER_ID_CHANGED, "payload");
export const dataChanged = makeActionCreator(DATA_CHANGED, "payload");
export const orderDataChanged = makeActionCreator(ORDER_DATA_CHANGED, "payload");
export const orderDataProblemDescriptionChanged = makeActionCreator(ORDER_DATA_PROBLEM_DESCRIPTION_CHANGED, "payload");
export const orderDataOfficialNameChanged = makeActionCreator(ORDER_DATA_OFFICIAL_NAME_CHANGED, "payload");
export const orderDataRequiredCreateNewOrderVersionChanged = makeActionCreator(ORDER_DATA_REQUIRED_CREATE_NEW_ORDER_VERSION_CHANGED, "payload");
export const orderDataVersionMetadataMessageChanged = makeActionCreator(ORDER_DATA_VERSION_METADATA_MESSAGE_CHANGED, "payload");
export const instructionVersionsChanged = makeActionCreator(INSTRUCTION_VERSIONS_CHANGED, "payload");
export const instructionVersionsDataChanged = makeActionCreator(INSTRUCTION_VERSION_DATA_CHANGED, "versionIndex", "dataIndex", "payload");
export const instructionVersionsParagraphAdd = makeActionCreator(INSTRUCTION_VERSION_PARAGRAPH_ADD, "versionIndex", "payload");
export const instructionWasEdited = makeActionCreator(INSTRUCTION_WAS_EDITED,"payload");
export const instructionVersionsParagraphDelete = makeActionCreator(INSTRUCTION_VERSION_PARAGRAPH_DELETE, "versionIndex", "dataIndex");
export const instructionLoading = makeActionCreator(INSTRUCTION_LOADING,"payload");
export const instructionParagraphUp = makeActionCreator(INSTRUCTION_PARAGRAPH_UP, "payload");
export const instructionParagraphDown = makeActionCreator(INSTRUCTION_PARAGRAPH_DOWN, "payload");
export const instructionSaveError = makeActionCreator(INSTRUCTION_SAVE_ERROR, "payload");

export function getInstructionData(orderId) {
  return async (dispatch, getState) => {
    try {
      let resp = await dispatch(apiFetch(`/api/instructions/order/${orderId}`));
      const jsonData = await resp.json();
      dispatch(dataChanged(jsonData.data));
      dispatch(orderDataChanged(jsonData.order));
      dispatch(instructionVersionsChanged(jsonData.versions));
      dispatch(orderDataRequiredCreateNewOrderVersionChanged(false));
      if (!resp.ok) {
        throw new Error(jsonData.message);
      }
    } catch (e) {
      toast(e.message, { type: "error" });
    }
  }
}

export function saveInstructionData() {
    return async (dispatch, getState) => {
      try {
        await dispatch(instructionLoading(true));
        await dispatch(instructionSaveError(""));
        //update order
        if(getState().instructionsReducer.requiredCreateNewOrderVersion) {
          const extraData = {
            versionMetadata: {message: getState().instructionsReducer.versionMetadataMessage},
            officialName: {officialName: getState().instructionsReducer.orderData.officialName}
          }
          await dispatch(orderLoadRequested(getState().instructionsReducer.orderId));
          await dispatch(newOrderVersionCreated(extraData));
          dispatch(orderDataRequiredCreateNewOrderVersionChanged(false));
        }

        const orderId = getState().instructionsReducer.orderId;
        const versionsCount = getState().instructionsReducer.versions.length;
        const data = getState().instructionsReducer.versions[versionsCount-1].data;
        let resp = await dispatch(
          apiFetch(`/api/instructions/order/${orderId}/save`, {
            method: "PATCH",
            body: JSON.stringify({
              data: data,
              message: getState().instructionsReducer.versionMetadataMessage
            })
          })
        );
        const jsonData = await resp.json();
        if (!resp.ok) {
          await dispatch(instructionLoading(false));
          await dispatch(instructionSaveError(jsonData.message));
          throw new Error(jsonData.message);
        }
        await dispatch(orderDataVersionMetadataMessageChanged(""));
        await dispatch(instructionLoading(false));
        await dispatch(instructionWasEdited(false));
        //update view
        let newVersion = await dispatch(apiFetch(`/api/instructions/order/${orderId}`));
        const jsonDataOfNewVersion = await newVersion.json();
        dispatch(dataChanged(jsonDataOfNewVersion.data));
        dispatch(orderDataChanged(jsonDataOfNewVersion.order));
        dispatch(instructionVersionsChanged(jsonDataOfNewVersion.versions));
        dispatch(orderDataRequiredCreateNewOrderVersionChanged(false));
      } catch (e) {
        toast(e.message, { type: "error" });
      }
    }
  }
